import React, { useEffect } from "react";

function PickTurnModal({ pickNumber, round, onDismiss }) {
    useEffect(() => {
        const timer = setTimeout(() => {
            onDismiss();
        }, 1350);

        return () => clearTimeout(timer);
    }, [onDismiss, pickNumber]);

    return (
        <div
            className="blind-draft-pick-turn-overlay"
            onClick={onDismiss}
            onKeyDown={(event) => event.key === "Escape" && onDismiss()}
            role="presentation"
        >
            <div
                className="blind-draft-pick-turn-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="blind-draft-pick-turn-title"
                onClick={(event) => event.stopPropagation()}
            >
                <p id="blind-draft-pick-turn-title" className="blind-draft-pick-turn-label">
                    Pick
                </p>
                <p className="blind-draft-pick-turn-number">#{pickNumber}</p>
                <p className="blind-draft-pick-turn-meta">Round {round}</p>
            </div>
        </div>
    );
}

export default PickTurnModal;
